import * as React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import Fab, { FabProps } from "@mui/material/Fab";
import { Link, LinkProps } from "react-router-dom";
import { IconButton, IconButtonProps } from "@mui/material";

export const LinkButton = (props: ButtonProps & LinkProps) => {
    return <Button LinkComponent={Link} {...props} />;
};

export const LinkFab = (props: FabProps & LinkProps) => {
    return <Fab LinkComponent={Link} {...props} />;
};

export const LinkIconButton = (props: IconButtonProps & LinkProps) => {
    return <IconButton LinkComponent={Link} {...props} />;
};
